
import { computed, defineComponent, ref } from "vue";

import TimerComp from "./TimerComp.vue";
import ITask from "@/interfaces/ITask";
import { useStore } from "@/store";

export default defineComponent({
  name: "FormComp",
  emits: ["onSaveTask"],
  methods: {},
  setup(props, context) {
    const store = useStore();

    const projects = computed(() => store.state.project.projects);
    const description = ref("");
    const projectId = ref("");

    const taskFinish = (timeInSeconds: number): void => {
      const project = projects.value.find(
        (project) => project.id === projectId.value
      ) || { id: "", name: "" };

      const payload: ITask = {
        id: new Date().toISOString(),
        description: description.value,
        timeInSeconds,
        project,
      };

      context.emit("onSaveTask", payload);
      description.value = "";
    };

    return {
      projects,
      description,
      projectId,
      taskFinish,
    };
  },
  components: {
    TimerComp,
  },
});
